// Updated CheckoutForm.js
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useState } from 'react';
import '../styles/CheckoutForm.css';
import { useNavigate, Link } from 'react-router-dom';
import { ReactComponent as CheckoutBackArrowIcon } from '../assets/images/checkout-back-arrow.svg';
import { ReactComponent as CheckoutPayArrowIcon } from '../assets/images/checkout_arrow.svg';

export default function CheckoutFormPages(props) {
  const email = props.email;
  const setEmail = props.setEmail;
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [saveInfo, setSaveInfo] = useState(false);
  const [showPromoCode, setShowPromoCode] = useState(false);
  const [promoCode, setPromoCode] = useState('');



  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const formattedAmount = props.amount !== undefined && props.amount !== null ?
    (Number(props.amount) === 0 ? "Free" : `$${Number(props.amount).toFixed(2)}`) :
    "$5.00";
  const formattedProductName = {
    'streamline': 'Streamline',
    'tailor': 'Tailor'
  }
  const handleApplyPromoCode = props.handleApplyPromoCode;
  const promoBypassed = props.promoBypassed;

  const handleBackClick = (e) => {
    e.preventDefault();
    navigate('/');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateEmail(email)) {
      setErrorMessage('Please enter a valid email address');
      return;
    }

    if (promoBypassed) {
      props.OnComplete(null, email);
      setIsProcessing(true);
      setErrorMessage('');
      return;
    } else {
      if (!stripe || !elements) {
        return; // Stripe.js has not loaded yet
      }
      setIsProcessing(true);
      setErrorMessage('');

      // Get the FULL result to properly check payment status
      const result = await stripe.confirmPayment({
        elements,
        confirmParams: {
          receipt_email: email,
        },
        redirect: "if_required",
      });


      if (result.error) {
        setErrorMessage(result.error.message);
        setIsProcessing(false);
      } else if (result.paymentIntent && result.paymentIntent.status === 'succeeded') {
        
        // Only call OnComplete when payment actually succeeds
        props.OnComplete(result.paymentIntent.id, email); // Pass the actual payment intent ID
      } else {
        setErrorMessage(`Payment not completed. Status: ${result.paymentIntent?.status || 'unknown'}`);
        setIsProcessing(false);
      }
    }
  };

  const togglePromoCode = () => {
    setShowPromoCode(!showPromoCode);
  };

  return (
    <div className="checkout-container">
      <h2 className="checkout-title">Secure Checkout</h2>
      <div className="checkout-header">
        <button type="button" className="back-button" onClick={handleBackClick}>
          <CheckoutBackArrowIcon className="back-button-icon" aria-hidden={true} />
          {formattedProductName[props.productName]} Resume
        </button>
      </div>

      <div className="checkout-total">
        <span>Total</span> 
        <h3>{formattedAmount}</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        {formattedAmount !== "Free" && (
        <div className="payment-element-container">
          <PaymentElement />
        </div>
        )}

        {errorMessage && (
          <div className="error-message">
            {errorMessage}
          </div>
        )}
        {formattedAmount !== "Free" && (
        <div className="promo-code-section">
          <button
            type="button"
            className="promo-code-toggle"
            onClick={togglePromoCode}
          >
            <span className="promo-code-toggle-icon">{showPromoCode ? '−' : '+'}</span>
            Apply Promo Code
          </button>

          {showPromoCode && (
            <div className="promo-code-input-container">
              <input
                type="text"
                className="promo-code-input"
                placeholder="Promo code"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
              />
              <button
                type="button"
                className="apply-promo-button"
                onClick={() => handleApplyPromoCode(promoCode)}
              >
                Apply
              </button>
            </div>
          )}
        </div>
        )}
        <button
          type="submit"
          className="pay-button"
          disabled={!stripe || isProcessing}
        >
          {isProcessing ? (
            'Processing...'
          ) : (
            <>
              {formattedAmount === "Free" ? "Continue" : "Pay and Continue"}{' '}
              <CheckoutPayArrowIcon className="pay-button-arrow" aria-hidden={true} />
            </>
          )}
        </button>
        <p className="checkout-pay-agreement">
          By clicking {formattedAmount === "Free" ? "Continue" : "Pay and Continue"}, you agree to our{' '}
          <Link to="/terms" className="checkout-pay-agreement-link">
            Terms
          </Link>{' '}
          and{' '}
          <Link to="/privacy-policy" className="checkout-pay-agreement-link">
            Privacy Policy
          </Link>
          .
        </p>
      </form>

      {formattedAmount !== "Free" && (
        <footer className="checkout-stripe-footer" role="contentinfo">
          <span className="checkout-stripe-brand">
            <span className="checkout-stripe-powered">Powered by</span>
            <span className="checkout-stripe-wordmark" aria-label="Stripe">
              stripe
            </span>
          </span>
          <span className="checkout-stripe-sep" aria-hidden="true">
            |
          </span>
          <Link to="https://stripe.com/legal/ssa" className="checkout-stripe-footer-link">
            Terms
          </Link>
          <Link to="https://stripe.com/privacy" className="checkout-stripe-footer-link">
            Privacy
          </Link>
        </footer>
      )}
    </div>
  );
}